import React from 'react';
import PropTypes from 'prop-types';
import MaterialUIButton from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Color from 'color';

import Theme from 'LegacyWeployDesignLanguage/Theme';
import dagstorp from 'LegacyWeployDesignLanguage/dagstorp';

const FLAT = 'flat';
const ROUNDED = 'rounded';

const PRIMARY = 'primary';
const SECONDARY = 'secondary';
const UTILITY = 'utility';
const TEXT = 'text';

const styles = {
  root: {
    paddingLeft: dagstorp.spacing[2],
    paddingRight: dagstorp.spacing[2],
    fontFamily: '"Intro", sans-serif',
    fontWeight: 600,
    height: '36px',
  },
  primary: {
    boxShadow: 'none',
    backgroundColor: Theme.colors.brand.primary,
    color: Theme.colors.text.primary,
    '&:hover': {
      backgroundColor: Color(Theme.colors.brand.primary).mix(Color(Theme.colors.text.primary), 0.04).string(),
    },
  },
  secondary: {
    boxShadow: 'none',
    backgroundColor: Theme.colors.white,
    color: Theme.colors.text.primary,
    '&:hover': {
      backgroundColor: Color(Theme.colors.text.primary).fade(0.96).string(),
    },
  },
  text: {
    color: Theme.colors.text.primary,
    borderStyle: 'solid',
    '&:hover': {
      backgroundColor: Color(Theme.colors.primary).fade(0.96).string(),
    },
  },
  utility: {
    boxShadow: 'none',
    backgroundColor: Theme.colors.gray,
    borderColor: Theme.colors.black,
    color: Theme.colors.black,
    borderWidth: '1px',
    borderStyle: 'solid',
    '&:hover': {
      backgroundColor: Theme.colors.darkGrey,
    },
  },
  rounded: {
    borderRadius: '20px',
  },
  disabled: {
    backgroundColor: Theme.colors.gray,
    color: Theme.colors.darkGrey,
  },
};

const Button = ({
  borderType,
  classes,
  className, // to insert styled-component class names
  appearance,
  ...rest
}) => (
  <MaterialUIButton
    className={[(classes[appearance] || classes.primary), classes[borderType], className].join(' ')}
    classes={{ disabled: classes.disabled, root: classes.root }}
    {...rest}
  />
);

Button.propTypes = {
  borderType: PropTypes.oneOf([FLAT, ROUNDED]),
  classes: PropTypes.object.isRequired,
  appearance: PropTypes.oneOf([PRIMARY, SECONDARY, UTILITY, TEXT]),
  className: PropTypes.string,
};

Button.defaultProps = {
  borderType: FLAT,
  appearance: PRIMARY,
  className: '',
};

Button.FLAT = FLAT;
Button.ROUNDED = ROUNDED;

Button.PRIMARY = PRIMARY;
Button.SECONDARY = SECONDARY;
Button.UTILITY = UTILITY;
Button.TEXT = TEXT;

export default withStyles(styles)(Button);
